module.exports = __webpack_public_path__ + "/images/ico-e-commerce-1.43faa9c.svg";